import React from "react"
import { Link } from "gatsby"
import { useInView } from "react-intersection-observer"

import Layout from "../../components/layout"
import Header from "../../components/header"
import Projects from "../../components/projects"

const ArtCenter = () => {
  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
  })

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  return (
    <Layout>
      <Header />
      <div className="project">
        <div className="container-fluid subheader">
          <div className="row">
            <div className="col-lg-4">
              <h2>07. Maria of Los Angeles</h2>
            </div>
            <div className="offset-lg-1 col-lg-3">
              <h2>2020</h2>
            </div>
            <div className="col-lg-4">
              <h2>Book Design, Typeface Design, Web </h2>
            </div>
          </div>
        </div>
        <div className="container-fluid p-0">
          <div className="row no-gutters">
            <div className="col-12 hero hero-mola">
              <div className={`hero-footer ${inView}`}>
                <div className="row justify-content-between align-items-end">
                  <div className="col-lg-5 d-none d-md-block">
                    <h2>
                      <Link to="/projects/pueblo-sonidero-mediatecture">
                        Previous Project(06) ↖
                      </Link>
                    </h2>
                    <h2>
                      <Link to="/projects/rifla">Next Project(08) ↗</Link>
                    </h2>
                  </div>
                  <div className="col-md-3 d-none d-md-block">
                    <h2>
                      <Link to="/">rg-rq.com</Link>
                    </h2>
                  </div>
                  <div className="offset-md-2 col-md-2">
                    <button onClick={scrollTop}>
                      <h2>
                        Back up
                        {inView ? (
                          <img
                            className="img-fluid"
                            src="/Up.svg"
                            alt="cheveron icon"
                          />
                        ) : (
                          <img
                            className="img-fluid"
                            src="/Up-white.svg"
                            alt="cheveron icon"
                          />
                        )}
                      </h2>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid content">
          <div className="row text-section">
            <div className="col-lg-5">
              <p>Beginnings</p>
            </div>
            <div className="col-lg-7">
              <p>
                MOLA began in 2015 when I started to collect the many diverse
                representations of the Virgen de Guadalupe in the city of Los
                Angeles.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/02_dp12ur.jpg"
                alt=""
              />
            </div>
          </div>
          <div className="row text-section">
            <div className="col-lg-5">
              <p>First Publication</p>
            </div>
            <div className="col-lg-7">
              <p>
                As the photographs increased in numbers I began to catalog the
                murals with the intentions of creating an image based
                publication under the mentorship of River Jukes-Hudson in 2018.
              </p>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/03_ht14sf.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/04_bdz6w4.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/05_jxp2bh.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/06_zo8fx8.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/07_se85h7.jpg"
                alt=""
              />
            </div>
          </div>
          <div className="row text-section">
            <div className="col-lg-5">
              <p>Book</p>
            </div>
            <div className="col-lg-7">
              <p>
                They have now become much more than images of these beautiful
                murals. They are an archive, a preservation of history, and a
                form of storytelling. I would love to tell the story not only of
                the murals and the artists, but also of those who have them in
                their businesses or homes.
              </p>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/08_ggsbfn.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/09_jkex19.jpg"
                alt=""
              />
            </div>
          </div>
          <div className="row text-section">
            <div className="col-lg-5">
              <p>Maria of Los Angeles</p>
            </div>
            <div className="col-lg-7">
              <p>
                This project is designed to serve the community of Los Angeles
                specifically the immigrant community, as the Virgen de Guadalupe
                has traveled with them or met them here in Los Angeles.
              </p>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/10_heuho0.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/11_ffiil5.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/12_z0b92h.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-3">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/13_dvj2br.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/14_d7js6m.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/15_crl77z.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/16_mbkwzn.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/17_lu89fl.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/18_yikdbt.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/19_dxdutw.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/20_w7jwkx.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/21_vuacht.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/22_v7ziia.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/23_oilwqy.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/24_bs4jm8.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/25_cpspfu.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/26_hmmnk5.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/27_qcvjzo.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/28_rhbhjx.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/29_u4mfrg.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/30_x2l9km.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/31_oijqf8.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/32_ftqehw.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/33_jmnrk3.jpg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-6">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/34_ciezjy.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/35_f6egcm.jpg"
                alt=""
              />
            </div>
            <div className="col-12">
              <img
                className="img-fluid"
                src="https://rgrq-old-website.s3.us-west-2.amazonaws.com/mola/36_bo3gv0.jpg"
                alt=""
              />
            </div>
          </div>

          <div className="row text-section">
            <div className="col-lg-5">
              <p>Special Thank You</p>
            </div>
            <div className="col-lg-7">
              <p>Stephen Serrato (Professor)</p>
              <p>River Jukes-Hudson (Professor)</p>
              <p>Miller Sherwood printing</p>
              <p>El Sereno Graphics</p>
              <p>Chromatic Inc.</p>
              <p>Roberto Lint Sagarena (Writer)</p>
              <p>Natalia Portillo</p>
              <p>Deysi Diaz</p>
              <p>Devin Diaz</p>
              <p>Maria de los Angeles</p>
              <p>Eliud Perez</p>
              <p>
                <a
                  href="https://www.instagram.com/el_kiko_81_/"
                  rel="noreferrer"
                  target="_blank"
                >
                  el_kiko_81_ (Trokero Locochon)
                </a>
              </p>
              <p>The community of los Angeles</p>
            </div>
          </div>
        </div>
      </div>
      <div ref={ref}></div>
      <Projects />
    </Layout>
  )
}
export default ArtCenter
